<template>
    <div class="quiz">
        <h1>Find Your Perfect UV Protection</h1>

        <div>
            <p>{{ question }}</p>

            <div class="questions" :class="questions_wrapper_class">
                <ul>
                    <li v-for="(o,i) in options" @click="answer = o" :key="i">
                        <span v-show="product">
                            <img :src="intro_image_source(o)">
                            <button :class="{ outline: answer === encodeUriSegment(o) }">{{ intro_image_text(o) }}</button>
                        </span>
                        <span v-if="!product && !lifestyle" class="foundation-formula">
                            <img :src="contentAssetPath(`img/${ slug(o) }.${ foundation ? 'jpg' : 'png' }`)">
                            <button :class="{ outline: answer === encodeUriSegment(o) }">{{ o }}</button>
                        </span>
                        <a v-show="lifestyle && !foundation" class="checkbox" :class="{ active: answer === encodeUriSegment(o) }">
                            <span>{{ o }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="nav">
            <span class="primary-link" :class="{ hidem: $route.name === 'product' }" @click="back">Back</span>
            <span class="primary-link" v-if="$route.name !== 'lifestyle' && $route.name !== 'coverage'" :class="{ disabled: !answer }" @click="next">Next</span>
            <span class="primary-link" v-if="$route.name === 'lifestyle' || $route.name === 'coverage'" :class="{ disabled: !answer }" @click="next">see results</span>
        </div>

        <span class="primary-link savedresults" v-if="product && showSaved" @click="loadSavedConsultation">View my previous results</span>
    </div>
</template>

<script>
import { analytics } from 'shiseido-apis'
import { encodeUriSegment, decodeUriSegment, contentAssetPath } from './utiliites/index'
import logic from './data/logic.json'

export default {
    data() {
        return {
            answer: null,
            showSaved: false,
        }
    },
    computed: {
        questions_wrapper_class() {
            return '--'.concat(this.$route.name)
        },
        product() {
            return this.$route.name.match(/product/i)
        },
        coverage() {
            return this.$route.name.match(/coverage/i)
        },
        question() {
            switch (this.$route.name) {
                case 'lifestyle':
                    return logic.questions[3]
                case 'coverage':
                    return logic.questions[2]
                case 'protect':
                    return logic.questions[1]
                case 'product':
                default:
                    return logic.questions[0]
            }
        },
        options() {
            const { product, protect, formula } = this.getDecodedParams()

            switch (this.$route.name) {
                case 'lifestyle':
                    return Object.keys(logic.logic[product][protect][formula])
                case 'coverage':
                    return Object.keys(logic.logic[product][protect])
                case 'protect':
                    return Object.keys(logic.logic[product])
                case 'product':
                    return Object.keys(logic.logic)
                default:
                    return []
            }
        },
        foundation() {
            return this.$route.params.hasOwnProperty('product') && this.$route.params.product.match(/foundation/i)
        },
        lifestyle() {
            return this.$route.name === 'lifestyle'
        },
    },
    watch: {
        $route() {
            this.answer = null

            this.checkForInvalidPath()
        },
        answer() {
            if (this.answer) {
                this.answer = encodeUriSegment(this.answer)
            }
        },
    },
    created() {
        this.checkForInvalidPath()

        if (this.$cookie.get('suncarefinder')) {
            this.showSaved = true
        }
    },
    methods: {
        loadSavedConsultation() {
            const previous_results = this.$cookie.get('suncarefinder')

            analytics.registerClick({
                toolname: 'Suncare Finder',
                element: 'View my previous results',
                question: this.$route.name,
                answers: [previous_results],
            })

            this.$emit('next', previous_results)
        },
        checkForInvalidPath() {
            const decoded_params = this.getDecodedParams()

            if (this.validResponses(decoded_params) && this.options[0] === 'N/A') {
                this.$emit('next', this.$route.fullPath.replace(/\/$/, '').concat('/N_fs_A'))
            }
        },
        validResponses(params = {}) {
            const { formula, protect, product } = params

            if (product && !logic.logic[product]) return this.redirectHome()
            if (protect && !logic.logic[product][protect]) return this.redirectHome()
            if (formula && !logic.logic[product][protect][formula]) return this.redirectHome()

            return true
        },
        redirectHome() {
            this.$emit('next', '/')
        },
        getNextPath() {
            const next_path = this.$route.fullPath
                .replace(/\/$/, '')
                .concat('/')
                .concat(this.answer)
                .concat('/')

            const { product, protect } = this.getDecodedParams()

            if (this.$route.name !== 'lifestyle') {
                if (!product && this.answer === 'Foundation') {
                    return next_path.concat('N_fs_A')
                }
                if (product && !protect) {
                    return next_path.concat('N_fs_A')
                }
                if (product && Object.keys(logic.logic[product])[0] === 'N/A') {
                    return next_path.concat('N_fs_A')
                }
                if (protect && Object.keys(logic.logic[product][protect])[0] === 'N/A') {
                    return next_path.concat('N_fs_A')
                }
            }

            return next_path
        },
        getDecodedParams() {
            const decoded_params = this.$route.params
            Object.keys(decoded_params).forEach((k) => {
                decoded_params[k] = decodeUriSegment(decoded_params[k])
            })

            return decoded_params
        },
        next() {
            analytics.registerClick({
                toolname: 'Suncare Finder',
                element: 'next',
                question: this.$route.name,
                answers: [this.answer],
            })

            this.$emit('next', this.getNextPath())
        },
        back() {
            analytics.registerClick({
                toolname: 'Suncare Finder',
                element: 'back',
                question: this.$route.name,
                answers: [],
            })

            const curr_path  = this.$route.fullPath.replace(/\/$/, '')
            const curr_steps = curr_path.split('/')
            const [last_step]  = curr_steps.slice(-1)
            const prev_steps = curr_steps.slice(0, last_step === 'N_fs_A' ? -2 : -1).map(encodeUriSegment)
            const next_path  = (prev_steps.length > 1 || prev_steps[0]) ? prev_steps.join('/') : '/'

            this.$emit('next', next_path)
        },
        intro_image_text(text) {
            if (text.includes('Active')) {
                return 'Active'
            }
            if (text.includes('Daily')) {
                return 'Daily'
            }
            if (text.includes('Foundation')) {
                return 'Foundation'
            }
        },
        intro_image_source(text) {
            if (text.includes('Active')) {
                return contentAssetPath('img/intro__active.jpg')
            }
            if (text.includes('Daily')) {
                return contentAssetPath('img/intro__daily.jpg')
            }
            if (text.includes('Foundation')) {
                return contentAssetPath('img/intro__foundation.jpg')
            }
        },
        slug(value) {
            if (!value) return ''

            return value
                .replace(/ /g,'-')
                .toLowerCase()
        },
        encodeUriSegment,
        contentAssetPath,
    },
}
</script>


// WEBPACK FOOTER //
// development/js/quiz.vue